import React from "react";
import PropTypes from "prop-types";
import { handleType, emailBuilder } from "../helpers";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    EmailShareButton
} from "react-share";

class InlineShare extends React.Component {
    render() {
        const { resource, isShareOpen, triggerShare } = this.props;
        const {
            description,
            src,
            thumbnail,
            title,
            type,
            emailSubject,
            emailBody,
            twitter,
            linkedin,
            facebook,
        } = resource;

        const typeFix = handleType(type);

        const messages = emailBuilder(emailBody);

        return (
            <section
                className={`share-box ${
                    isShareOpen ? "is-active" : ""
                }`}
            >
                <div className="share-box__top">
                    <h3 className="share-box__title">Share {typeFix}</h3>
                    <button
                        className="modal__trig"
                        onClick={triggerShare}
                    >
                        <i className="fal fa-times" />
                    </button>
                </div>
                <section className="modal-share-btns">
                    <FacebookShareButton url={src} quote={`${facebook}`}>
                        <button
                            className="modal-btn modal-btn--fb"
                            data-social-bookmark={`Facebook`}
                        >
                            Facebook
                        </button>
                    </FacebookShareButton>
                    <LinkedinShareButton
                        url={src}
                        title={title}
                        description={`${linkedin}`}
                    >
                        <button
                            data-social-bookmark={`LinkedIn`}
                            className="modal-btn modal-btn--li"
                        >
                            Linkedin
                        </button>
                    </LinkedinShareButton>
                    <EmailShareButton
                        url={src}
                        subject={`${emailSubject}`}
                        body={`${messages}\n\n${src}`}
                    >
                        <button
                            className="modal-btn modal-btn--email"
                            data-social-bookmark={`Email`}
                        >
                            Email
                        </button>
                    </EmailShareButton>
                    <TwitterShareButton url={src} title={`${twitter}`}>
                        <button
                            className="modal-btn modal-btn--twit"
                            data-social-bookmark={`Twitter`}
                        >
                            Twitter
                        </button>
                    </TwitterShareButton>
                </section>
            </section>
        );
    }
}

export default InlineShare;



// WEBPACK FOOTER //
// ./src/components/InlineShare.js